function cleanValues(data) {
  return Object.entries(data).reduce((acc, _ref) => {
    let [key, value] = _ref;
    // delete any undefined values
    if (typeof value === 'boolean' || value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
export default cleanValues;